<template>
  <section class="container mx-auto py-6 md:py-15">
    <h2 class="section-heading text-center md:text-left">
      Discover Our Steps to Exceptional Journey
    </h2>

    <div
      class="flex flex-col md:flex-row w-full mt-8 md:mt-14 journey gap-y-7 md:gap-y-0"
    >
      <template v-if="isLoading">
        <div
          v-for="i in 3"
          :key="i"
          class="flex flex-col gap-6 px-5 container mx-auto"
        >
          <UtilsSkeletonLoading class="w-full h-40" />
          <UtilsSkeletonLoading class="w-full h-16" />
          <UtilsSkeletonLoading class="w-full h-36" />
        </div>
      </template>
      <template v-else>
        <div
          v-for="(journey, index) in journeyData?.attributes?.timelines"
          :key="index"
          class="journey-wrapper w-full md:w-1/3 flex flex-col-reverse md:flex-col"
        >
          <div class="journey-img md:h-32 flex md:mb-7 mt-3 md:mt-0">
            <NuxtImg
              format="webp"
              srcset=""
              :src="journey.image?.data?.attributes?.url"
              :alt="journey.title || 'Journey'"
              :title="journey.title"
              loading="lazy"
              class="ml-10 w-2/3 my-auto"
            />
          </div>
          <div class="journey-body">
            <div class="journey-title flex items-center">
              <div class="flex items-center">
                <span class="circle-dot">
                  <span class="circle-dot--iner"></span>
                </span>
                <span
                  class="text-lg sm:text-[26px] sm:leading-normal font-medium text-primary-primary pl-3 pr-2 bg-white z-[1]"
                >
                  {{ journey?.title }}
                </span>
              </div>
              <hr class="line-dash" />
            </div>
            <div class="ml-10">
              <span class="text-[#8F8F8F] text-base sm:text-lg">{{
                journey?.period
              }}</span>
            </div>
            <div
              class="flex ml-10 mt-6 journey-content"
              v-html="journey?.content"
            ></div>
          </div>
        </div>
      </template>
    </div>

    <div class="mx-auto text-center mt-8 md:mt-10">
      <NuxtLink
        to="/about/history"
        title="History"
        class="btn btn-md md:btn-lg btn-primary-reverse w-max mx-auto"
      >
        View Our Journey
      </NuxtLink>
    </div>
  </section>
</template>

<script setup>
const isLoading = ref(true)

const journeyData = ref([])

const getJourneyData = async () => {
  const { data, error, pending } = await useSuitmediaApiData(`/api/timeline`, {
    query: {
      'fields[0]': 'id',
      'populate[timelines][populate][0]': 'image'
    }
  })

  isLoading.value = pending.value

  if (error.value) {
    throw createError({
      statusCode: 404,
      message: `Journey/Timeline does not exist`
    })
  }

  return data.value
}

const journeys = await getJourneyData()
journeyData.value = journeys.data
</script>

<style lang="scss" scoped>
.circle-dot {
  display: flex;
  width: 25px;
  height: 25px;
  background: white;
  border-radius: 50%;
  border: 1px solid #ff6700;
  // margin-right: 12px;

  z-index: 2;

  .circle-dot--iner {
    display: block;
    width: 10px;
    height: 10px;
    background: #ff6700;
    border-radius: 50%;

    align-self: center;
    margin: auto;
  }
}

.journey-body {
  position: relative;
  &::after {
    position: absolute;
    content: '';
    width: 1px;
    background-color: #e6e7e8;
    top: 10px;
    bottom: 0;
    left: 12px;
    z-index: 1;
  }
}
.journey {
  position: relative;
  &::after {
    position: absolute;
    content: '';
    width: 1px;
    background-color: #e6e7e8;
    top: 10px;
    bottom: 0;
    left: 12px;
    z-index: 1;

    @media screen and (min-width: 768px) {
      width: 0;
      background-color: none;
      z-index: 0;
    }
  }
}

.line-dash {
  position: absolute;
  border: none;
  // border-top: 1px dashed #ceced1;
  height: 1px;
  width: 100%;
  margin-left: 8px;
  border-width: 2px;

  background: linear-gradient(to right, transparent 50%, #ceced1 50%);
  background-size:
    16px 2px,
    100% 2px;
}

:deep(.journey-content) {
  ul {
    width: 100%;
    list-style-type: disc;
    margin-left: 1rem;

    font-size: 14px;
    line-height: 20px;
    font-weight: normal;
    color: #3d3d3d;

    @media screen and (min-width: 768px) {
      font-size: 16px;
      line-height: 24px;
    }
  }
}
</style>
